import {
  U21Modal,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { U21DataLabelSelect } from 'app/shared/u21-ui/components/dashboard';
import { ReactNode, useState } from 'react';

interface EditDataLabelsModalProps {
  tagIds: (string | number)[];
  editObjectTags: (tagIds: (string | number)[]) => Promise<void>;
  isEditLoading: boolean;
  title: ReactNode;
  open: boolean;
  handleClose: () => void;
}

export const EditDataLabelsModal = ({
  tagIds: objectTagIds,
  editObjectTags,
  isEditLoading,
  title,
  open,
  handleClose,
}: EditDataLabelsModalProps) => {
  const [tagIdsStaged, setTagIdStaged] =
    useState<(number | string)[]>(objectTagIds);
  const handleChange = (tagIds: (string | number)[]) => {
    setTagIdStaged(tagIds);
  };

  return (
    <U21Modal
      actionButtonProps={{
        loading: isEditLoading,
      }}
      open={open}
      title={title}
      disableTitleCase
      onClose={() => {
        handleClose();
        setTagIdStaged(objectTagIds);
      }}
      onAction={async () => {
        try {
          await editObjectTags(tagIdsStaged);
          handleClose();
        } catch {
          // No-op because the error has already been handled.
        }
      }}
    >
      <U21Spacer spacing={2}>
        <U21Typography color="text.secondary">
          Add or remove tags using the dropdown below.
        </U21Typography>
        <U21DataLabelSelect
          onChange={handleChange}
          value={tagIdsStaged}
          label="Tags"
        />
      </U21Spacer>
    </U21Modal>
  );
};
